import { render, staticRenderFns } from "./ServersList.vue?vue&type=template&id=34e0dcbe"
import script from "./ServersList.vue?vue&type=script&lang=js"
export * from "./ServersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports